<template>
  <div class="page-box">
    <van-overlay class="box-center" :show="dialogLoading">
      <van-loading type="spinner" size="40px" vertical></van-loading>
    </van-overlay>
    <div class="organizer-box">
      <img class="magnifyingGlass-icon" src="@/assets/img/filing/magnifyingGlassIcon.png" alt="">
      <div class="welcome">
        <b class="b">您好!</b>
        <div class="msg">
        您正在进行快应用真实性核验
        </div>
      </div>
      <div class="organizer">
        <div class="item">
            <div class="label">核验主体：</div>
            <div class="value">
              {{info.dwmc}}
            </div>
        </div>
        <div class="item">
            <div class="label">核验快应用：</div>
            <div class="value">
                {{info.wzmc}}
            </div>
        </div>
      </div>
    </div>
    <div class="notice-box">
      <div class="b margin-b10">
        注意：
      </div>
      <div class="msg margin-l30 margin-b10">
        如果您并非该主体下的快应用的负责人，请勿帮他人核验。否则他人利用该快应用进行诈骗、赌博等非法活动时，你会承担相应的法律责任！
      </div>
      <div class="msg margin-l30">
        每个快应用每天仅有三次核验机会，请提前准备好所有的材料，然后进行电子核验。
      </div>
    </div>
    <van-button color="#1989fa" class="start-btn" @click.prevent="onStartVerify">开始核验</van-button>
  </div>
</template>
<script>
import FingerprintJS from '@fingerprintjs/fingerprintjs' // 引入
export default {
  data() {
    return {
      dialogLoading:false,
      info:{}
    };
  },
  created() {
    if(this.$route.query.filingsRecordCode){
      localStorage.setItem('filingsRecordCode',this.$route.query.filingsRecordCode);
      this.queryAccountInfo();
      if(!localStorage.getItem('userAgent')){
        this.getvisitorId();
      }
    }else{
      this.$dialog.alert({
        message: `缺失filingsRecordCode，请从新扫码`,
        confirmButtonColor:'#4285f5',
      });
    }
  },
  methods: {
    // 获取设备或浏览器唯一标识
    async getvisitorId() {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      localStorage.setItem('userAgent',result.visitorId)
    },
    // 获取核验主体信息
    queryAccountInfo() {
      this.$apis.filingServer.queryAccountInfo({
        filingsRecordCode:this.$route.query.filingsRecordCode,
      }).then(res=>{
        if (res['code'] == 0) {
          this.info = res['data'];
        } else {
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonColor:'#4285f5',
          });
        }
      })
    },
    onStartVerify(){
      this.$dialog.confirm({
        message:`请在30分钟内完成电子核验，超时会导致核验失败。`,
        confirmButtonText:'立即核验',
        confirmButtonColor:'#4285f5',
        cancelButtonText:'稍后核验',
        cancelButtonColor:'#4285f5',
      }).then(res => {
          this.queryVerifing();
      });
    },
    // 开始核验
    queryVerifing(){
      const query = this.$route.query
      this.dialogLoading = true;
      // 检查当然核验机会
      this.$apis.filingServer.startVerify({
        filingsRecordCode: localStorage.getItem('filingsRecordCode'),
        userAgent: localStorage.getItem('userAgent'),
      }).then(res=>{
        if (res['code'] == 0) {
          // 存储核验主体信息
          this.$store.dispatch("filingStore/addInfo", this.info);
          // 查看当前核验进度
          this.$apis.filingServer.queryVerifing({
            filingsRecordCode: localStorage.getItem('filingsRecordCode'),
            userAgent: localStorage.getItem('userAgent'),
          }).then(res => {
            this.dialogLoading = false;
            if (res['code'] == 0) {
              // 电子化核验状态：1进行中 2核验失败 3核验成功 4超时
              if(res['data']['status'] == 1){
                if(res['data']['faceLiveStatus'] == 3 && res['data']['verifyImgUrl']){//活体成功 && 已上传活体图片
                  this.$router.push({ 
                    path: '/filing/process/result/info',
                    query
                  });
                }else if(res['data']['rpkBackStatus'] == 3){//应用负责人证件反面成功
                  this.$router.push({ 
                    path: '/filing/process/quickApp/faceliveness',
                    query
                  });
                }else if(res['data']['rpkFrontStatus'] == 3){//应用负责人证件正面成功
                  this.$router.push({ 
                    path: '/filing/process/quickApp/fzrXm2',
                    query
                  });
                }else if(res['data']['accountBackStatus'] == 3){//单位负责人证件反面成功
                  this.$router.push({ 
                    path: '/filing/process/quickApp/fzrXm1',
                    query
                  });
                }else if(res['data']['accountFrontStatus'] == 3){//单位负责人证件正面成功
                  this.$router.push({ 
                    path: '/filing/process/organizer/fzrXm2',
                    query
                  });
                }else if(res['data']['accountStatus'] == 3){//单位证件成功
                  this.$router.push({ 
                    path: '/filing/process/organizer/fzrXm1',
                    query
                  });
                }else {
                  // 去起始步骤
                  this.$router.push({ 
                    path: '/filing/process/organizer/zjhm',
                    query
                  });
                }
              }else{
                this.$dialog.alert({
                  message: `电子化核验异常：${res['data']['status']}`,
                  confirmButtonText:'好的',
                  confirmButtonColor:'#4285f5',
                });
              }
            } else {
              this.$dialog.alert({
                message: res['msg'],
                confirmButtonText:'好的',
                confirmButtonColor:'#4285f5',
              });
            }
          });
        } else {
          this.dialogLoading = false;
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonColor:'#4285f5',
          });
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.page-box {
  max-width: 750px;
  margin: auto;
  padding: 50px;
  .organizer-box{
    margin: auto;
    height: 760px;
    padding:0 50px;
    padding-top: 150px;
    border: 1px solid rgba(215, 215, 215, 1);
    border-radius: 10px;
    .magnifyingGlass-icon{
      display: block;
      margin: auto;
      width: 150px;
    }
    .welcome{
      margin-top: 60px;
      text-align: center;
      font-size: 30px;
      color: #333;
     .b{
        font-size: 38px;
        color: #333;
      }
     .msg{
        margin-top: 30px;
        color: #999;
     }
    }
    .organizer{
      margin-top: 40px;
      padding-top: 30px;
      border-top: 1px solid rgba(215, 215, 215, 1);
      font-size: 28px;
      .item{
        display:flex;
        margin-top: 20px;    
       .label{
          color: #999;
          margin-right: 10px;
          line-height: 36px;
        }
       .value{
          flex: 1;
          color: #333;
          line-height: 36px;
        }
      }
    }
  }
  .notice-box{
    margin-top: 40px;
    font-size: 26px;
    color: #F59A23;
    .b{
      font-weight: bold;
    }
    .msg{
      line-height: 38px;
    }
  }
  .start-btn{
    display: block;
    margin: auto;
    padding: 0 60px ;
    margin-top: 40px;
    border-radius: 10px;
  }
}
</style>
